import React from "react";
import {connect} from 'react-redux';
import {Redirect} from "react-router-dom";

import {loginUser} from './reducer';

const LoginComponent = (props) => {

    let username, password;

    if (props.user.isAuthenticated) {
        return (
            <Redirect to="/admin"/>
        )
    }

    const loginUser = (event) => {
        let user = username.value;
        let pw = password.value;

        if (!user || !pw || user === '' || pw === '') {
            return;
        }

        props.loginUser(user, pw);
    };

    const keyPressed = (event) => {
        if (event.keyCode === 13) {
            loginUser();
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card-group mb-0">
                        <div className="card p-4">
                            <div className="card-block">
                                <h1>Login</h1>
                                <p className="text-muted">Melden Sie sich mit Ihrem Account an</p>
                                <div className="input-group mb-3">
                                    <input id="username" type="text" onKeyDown={keyPressed} className="form-control" placeholder="Username" ref={ el => username = el }/>
                                </div>
                                <div className="input-gro up mb-4">
                                    <input id="password" type="password" onKeyDown={keyPressed} className="form-control" placeholder="Password" ref={ el => password = el }/>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <button type="button" className="btn btn-primary px-4"
                                                onClick={loginUser}>Login
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

function mapStateToProps(state) {
    return {
        user: state.security.get('user').toJS()
    };
}

export default connect(mapStateToProps, {loginUser})(LoginComponent);



// WEBPACK FOOTER //
// ./src/admin/security/LoginComponent.js